import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Send, Loader2 } from "lucide-react";

const MODELS = [
  "KTM — Naked / Duke",
  "KTM — Adventure",
  "KTM — Enduro",
  "KTM — SuperMoto",
  "Husqvarna — Naked (Svartpilen / Vitpilen)",
  "Husqvarna — Enduro",
  "Husqvarna — Motocross",
  "GasGas Trial",
  "Altro modello",
];

const SLOTS = [
  { v: "morning", l: "Mattina (08:30–12:30)" },
  { v: "afternoon", l: "Pomeriggio (14:30–19:00)" },
  { v: "saturday", l: "Sabato mattina" },
  { v: "any", l: "Qualsiasi orario" },
];

export default function TestRideForm() {
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", phone: "", model: MODELS[0], slot: "morning", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const message = `Richiesta TEST RIDE\nModello: ${form.model}\nFascia oraria preferita: ${SLOTS.find(s => s.v === form.slot)?.l || form.slot}\n\n${form.message || ""}`.trim();
      await api.post("/contact", {
        name: `${form.first_name} ${form.last_name}`.trim(),
        email: form.email,
        phone: form.phone,
        subject: `Test ride ${form.model}`,
        message,
        section: "moto",
      });
      setSent(true);
      setForm({ first_name: "", last_name: "", email: "", phone: "", model: MODELS[0], slot: "morning", message: "" });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="bg-white p-8 md:p-10 card-flat" data-testid="testride-sent">
        <span className="label-eyebrow text-[color:var(--nsa-orange)]">Prenotazione inviata</span>
        <h3 className="font-display uppercase text-2xl md:text-3xl mt-2">A presto in sella!</h3>
        <p className="mt-3 text-gray-600">Ti contatteremo entro breve per confermare il test ride.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="bg-white p-6 md:p-8 card-flat space-y-4" data-testid="testride-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input testid="tr-fn" label="Nome" value={form.first_name} onChange={(v) => setForm({ ...form, first_name: v })} required />
        <Input testid="tr-ln" label="Cognome" value={form.last_name} onChange={(v) => setForm({ ...form, last_name: v })} required />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input testid="tr-email" label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} required />
        <Input testid="tr-phone" label="Telefono" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} required />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select testid="tr-model" label="Modello di interesse" value={form.model} onChange={(v) => setForm({ ...form, model: v })} options={MODELS.map((m) => ({ v: m, l: m }))} />
        <Select testid="tr-slot" label="Fascia oraria preferita" value={form.slot} onChange={(v) => setForm({ ...form, slot: v })} options={SLOTS} />
      </div>
      <div>
        <label className="label-eyebrow text-gray-500 block mb-2">Note (opzionale)</label>
        <textarea
          value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          rows={3}
          className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-[color:var(--nsa-orange)]"
          placeholder="Preferenze, giorno indicativo, esperienza di guida..."
          data-testid="tr-message"
        />
      </div>
      {err && <div className="text-red-600 text-sm" data-testid="tr-error">{err}</div>}
      <button
        type="submit"
        disabled={loading}
        className="btn-orange label-eyebrow px-6 py-4 inline-flex items-center gap-3 disabled:opacity-60"
        data-testid="tr-submit"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
        Richiedi test ride gratuito
      </button>
    </form>
  );
}

function Input({ label, value, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="label-eyebrow text-gray-500 block mb-2">{label}{required && "*"}</label>
      <input
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-[color:var(--nsa-orange)]"
        data-testid={testid}
      />
    </div>
  );
}

function Select({ label, value, onChange, options, testid }) {
  return (
    <div>
      <label className="label-eyebrow text-gray-500 block mb-2">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-gray-300 px-4 py-3 focus:outline-none focus:border-[color:var(--nsa-orange)] bg-white"
        data-testid={testid}
      >
        {options.map((o) => (
          <option key={o.v} value={o.v}>{o.l}</option>
        ))}
      </select>
    </div>
  );
}
